define(["data/config"], function (config) {
    var apply = function ($element, params) {
        var $amount = $element.find('.c_uiOptions');
        var $amountOther = $element.find(".js_surveyAmountOther");
        var $submit = $element.find(".js_surveySubmit");
        var $userInfo = $element.find("#user-info");

        $submit.on("click", function (e) {
            $(this).addClass("c_uiButton--loading");
        });

        $amount.on("click", function (e) {
            let $target = $(e.target);
            if ($target.is('input') && $target.val() !== 'on' && $target.val() > 0) {
                $submit.text($submit.data("label-checkout"));
                $userInfo.removeClass('u_hidden');
                $userInfo.find('input[name=name]').attr('required', true);
                $userInfo.find('input[name=email]').attr('required', true);
            } else {
                $submit.text($submit.data("label-submit"));
                $userInfo.addClass('u_hidden');
                $userInfo.find('input[name=name]').removeAttr('required', true);
                $userInfo.find('input[name=email]').removeAttr('required', true);
            }
        });

        $amountOther.on("keyup", function (e) {
            $amountOther.val($amountOther.val().replace(/[^\d]/, ''));

            if (!isNaN($amountOther.val()) && $amountOther.val() > 0) {
                $submit.text($submit.data("label-checkout"));
                $userInfo.removeClass('u_hidden');
                $userInfo.find('input[name=name]').attr('required', true);
                $userInfo.find('input[name=email]').attr('required', true);
            } else {
                $submit.text($submit.data("label-submit"));
                $userInfo.addClass('u_hidden');
                $userInfo.find('input[name=name]').removeAttr('required', true);
                $userInfo.find('input[name=email]').removeAttr('required', true);
            }
        });
    };

    return {
        name: "survey",
        apply: apply
    };
});
